import * as React from 'react';
import { useState } from 'react';
import AddToCart from "../../../component/Global/Cart/AddToCart";
import QuantityPicker from "../../../component/Global/Cart/QuantityPicker";
import { AddPartAutoComplete } from 'src/reusable/product';
import useReduxState from 'src/hooks/useReduxState';
import System from "../../../helper/system";
import FadeInOut from "../../../component/FadeInOut";
import PriceTable from "../../../component/Global/Cart/PriceTable";
import useDebounce from "../../../hooks/useDebounce";
import CartCommon from "src/component/Global/Cart/Common";
import { SET_OBSOLETE_EOL_INVALID_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT } from 'src/store/slice/model/Cart';
import store from 'src/storeWire';
import { useCartStore } from 'src/hooks/cart';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const CartManuallyAddPart = (props) => {
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const [QuoteStatus, setQuoteStatus] = useState(false)
    const [invalidQtyInventory, setInvalidQtyInventory] = useState(false)
    const [need_message_display_slug, set_need_message_display_slug] = useDebounce(false, 200)
    const [countQuantityPicker, setCountQuantityPicker] = useDebounce(0, 1000)
    const [ObsoleteFailedFlag, setObsoleteFailedFlag] = useState(true);
    const [EndOfLifeOFlagFailedFlag, setEndOfLifeOFlagFailedFlag] = useState(true);
    const [isProductExists, setIsProductExists] = useState(false);

    const [{ CART_DATA_OBJECT }, { }, { }] = useCartStore();


    const inInsufficientQuantityMessageDisplayStatus = () => {
        if (QuoteStatus === true) {
            return false;
        }
        if (productSelected && productSelected.assets !== undefined && productSelected.assets.inventory !== undefined && productSelected.assets.pricing.quantity < 1) {
            return true;
        }
        return false;
    };
    const getSelectedProductInventory = () => {
        if (productSelected && productSelected.assets !== undefined && productSelected.assets.inventory !== undefined) {
            return productSelected.assets.inventory;
        }
        return false;
    };
    const getSelectedProductPricing = () => {
        if (productSelected && productSelected.assets !== undefined && productSelected.assets.pricing !== undefined) {
            return productSelected.assets.pricing;
        }
        return [];
    };
    const alreadyInCartValidationMessage = () => {
        return (
            <div className="text-red cart-head-input-error text-nowrap m-t-15">
                <b>{productSelected.ERPMFRPartNumber}:</b> This item is already added in the cart.
            </div>
        );
    };

    const alreadyInCartValidationMessageStatus = () => {
        return productSelected.ItemNumber !== undefined &&
            CART_DATA_OBJECT !== undefined && CART_DATA_OBJECT[productSelected.ItemNumber] !== undefined;
    };

    const fakePlaceHolder = () => {
        return (
            <>
                <div className="d-flex flex-column position-relative w200">
                    <div className="quantity w-auto clearfix" id='Quantity'>
                        <div className="quantity-picker disabled">
                            <div className="bs5 input-group flex-nowrap border-0">
                                <span className="bs5 input-group-prepend flex-nowrap">
                                    <button type="button" className="btn btn-outline-secondary btn-number br-0"
                                        data-type="minus" data-field="quant[1]" aria-label="Decrease Quantity">
                                        <span className="fa fa-minus"></span>
                                    </button>
                                </span>
                                <input type="text" name="quant[1]" className="form-control input-number"
                                    value="0" min="0" max="10" aria-labelledby="Quantity" onChange={() => { }} />
                                <span className="input-group-append">
                                    <button type="button" className="btn btn-outline-secondary btn-number bl-0"
                                        data-type="plus" data-field="quant[1]" aria-label="Increase Quantity">
                                        <span className="fa fa-plus"></span>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <button className="bs5 btn btn-secondary btn-sm w180 disabled h30">UPDATE CART</button>
            </>
        );
    };

    React.useEffect(() => {
        async function f() {
            if (countQuantityPicker > 0) {
                await updateToCartServer(countQuantityPicker);
            }
        }

        f();
    }, [countQuantityPicker]);

    // DT - 2 March - when product is added check for the onbsolute/EOL part
    React.useEffect(() => {
        async function f() {
            if (productSelected?.Quantity > 0) {
                await updateToCartServer(productSelected?.Quantity);
            }
        }
        setIsProductExists(alreadyInCartValidationMessageStatus());
        f();
    }, [productSelected]);

    const obsoleteEOLValidationReduxDispatch = (status = true) => {
        store.dispatch(SET_OBSOLETE_EOL_INVALID_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
            CART_DATA: {
                ItemNumber: productSelected.ItemNumber,
                obsolete_EOL_invalidate_message_active: status,
            }
        }));
    }

    const updateToCartServer = async (quantityUpdateToCartInput) => {
        let flag = new CartCommon().getObsoleteFailedFlag(productSelected, quantityUpdateToCartInput, getSelectedProductInventory());
        if (flag === true) {
            setObsoleteFailedFlag(false);
            obsoleteEOLValidationReduxDispatch();
            System.popup('ObsoleteOutOfStockPopup', {//quantity below
                ERPMFRPartNumber: productSelected.ERPMFRPartNumber, ObsoleteFlag: productSelected.ObsoleteFlag, quantity: getSelectedProductInventory().quantity
            });
            return false;
        }

        setEndOfLifeOFlagFailedFlag(true);
        setObsoleteFailedFlag(true);
        updateCartEvent();
    };


    //By Ramya Kannan [update cart - Adobe script ]
    function updateCartEvent() {
        localStorage.setItem("adobeEventType", "addToCartEvent");
        let prodDetails = productSelected;
        let cartDetails = {
            "additionSource": "cartView",
            "cartType": "checkout"
        }
        if (Object.keys(prodDetails).length && Object.keys(cartDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
        }

    }
    return (
        <>
            <FadeInOut show={true} duration={500} style={{}}>
                <div className="bs5 row">
                    <div className="col-12">
                        <div className="my-cart-head mt-2">
                            <div className="d-flex justify-content-start justify-content-md-between align-items-start flex-column flex-md-row">
                                <h4>Manually Add Part</h4>
                                <div>
                                    <AddPartAutoComplete />
                                    {isProductExists &&
                                        <div className="d-flex">
                                            {alreadyInCartValidationMessage()}
                                        </div>
                                    }
                                </div>
                                {productSelected.ERPPartNumber !== undefined &&
                                    <>
                                        <div style={{ visibility: isProductExists ? 'hidden' : 'visible' }} className="d-flex flex-column position-relative w200">
                                            <QuantityPicker
                                                invalid_quantity_message_text={"The quantity you've selected does not meet our minimum/multiple order requirements. Please re-enter your desired quantity."}
                                                showDisplayQtyMinQtyMult={'yes'}
                                                force_default_min_quantity={true}
                                                ObsoleteFlag={ObsoleteFailedFlag}
                                                EndOfLifeFlag={EndOfLifeOFlagFailedFlag}
                                                disable_edit_force_default_quantity={true}
                                                readOnly_quantity={!(
                                                    QuoteStatus === false && productSelected.ERPPartNumber !== undefined || (QuoteStatus === false && productSelected.ERPPartNumber !== undefined || inInsufficientQuantityMessageDisplayStatus())
                                                )}
                                                single_product_pricing_list={getSelectedProductPricing()}
                                                single_product_inventory={getSelectedProductInventory()}
                                                single_product={productSelected}
                                                getPlanInputQuantityValidatedCallback={async (count) => {
                                                    setCountQuantityPicker(count)
                                                }}
                                            />
                                            <div style={{ display: "none" }}>
                                                <PriceTable
                                                    single_product_pricing_list={getSelectedProductPricing()}
                                                    single_product_inventory={getSelectedProductInventory()}
                                                    single_product={productSelected} />
                                            </div>
                                        </div>
                                        <div style={{ visibility: isProductExists ? 'hidden' : 'visible' }} className={'spinner-loader'}>
                                            <AddToCart
                                                hideAdditionalQuoteBtn={true}
                                                dontOpenAddedToCartPopup={true}
                                                setInvalidQtyInventory={setInvalidQtyInventory}
                                                productAddedToCartCallback={() => {
                                                    System.alert('Part has been successfully added to your cart.', 'success', '', true);
                                                    setProductSelected({})
                                                    setSearchTerm('')
                                                    set_need_message_display_slug(false)
                                                    setTimeout(() => {
                                                        document.body.style.overflow = '';
                                                    }, 400)
                                                }}
                                                customAddToCartButton={() => (
                                                    <>
                                                        <button className={invalidQtyInventory ? "bs5 btn btn-secondary btn-sm w180 h30 disabled" : "bs5 btn btn-secondary btn-sm w180 h30"}>
                                                            UPDATE CART
                                                        </button>
                                                        {set_need_message_display_slug(false)}
                                                    </>
                                                )}
                                                customQuoteButton={() => (
                                                    <>
                                                        <button className="bs5 btn btn-secondary btn-sm w180 h30">
                                                            Click To Quote
                                                        </button>
                                                        {set_need_message_display_slug('quote')}
                                                    </>
                                                )}
                                                customContactUsButton={() => (
                                                    <>
                                                        <button className="bs5 btn btn-secondary btn-sm w180 h30">
                                                            Contact Us
                                                        </button>
                                                        {set_need_message_display_slug('contact')}
                                                    </>
                                                )}
                                                addToQuoteStatusCallback={(status) => {
                                                    setQuoteStatus(status)
                                                }}
                                                single_product_pricing_list={getSelectedProductPricing()}
                                                single_product_inventory={getSelectedProductInventory()}
                                                single_product={productSelected}
                                                initialDispatchOnFirstLoad={true}
                                                isFrom="Cart"
                                            />
                                            {productSelected.ERPPartNumber === undefined &&
                                                <button
                                                    className="bs5 btn btn-secondary btn-sm w180 disabled h30">UPDATE CART
                                                </button>
                                            }
                                        </div>
                                    </>
                                }
                                {productSelected.ERPPartNumber === undefined &&
                                    <>
                                        {fakePlaceHolder()}
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </FadeInOut>
        </>
    );
}

export default CartManuallyAddPart;